<template>
  <v-layout column>
    <v-flex>
      <v-card>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">{{ $t("labels.status") }}</h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout column>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.requestInfoUpdate") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateReqUpdatedInfo"
                  v-model="reqUpdatedInfo"
                  :labels="true"
                  :value="reqUpdatedInfo"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.hideCommerical") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateHideCommercial"
                  v-model="hideCommercial"
                  :labels="true"
                  :value="hideCommercial"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.testLocation") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateTestStore"
                  v-model="testStore"
                  :labels="true"
                  :value="testStore"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.softwareInstalled") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateInstallation"
                  v-model="installationDone"
                  :labels="{ checked: 'Yes', unchecked: 'No' }"
                  :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }"
                  :value="installationDone"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>Twilio Text Alert</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateTwilioAlert"
                  v-model="twilioAlert"
                  :labels="{ checked: 'Yes', unchecked: 'No' }"
                  :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }"
                  :value="twilioAlert"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import locationService from '../service.js';

export default {
  data() {
    return {
      testStore: false,
      reqUpdateInfo: false,
      hideCommercial: false,
      installationDone: false,
      twilioAlert: false,
    };
  },
  created() {
    this.setStatus();
    console.log('location', location)
  },
  watch: {
    location() {
      this.setStatus();
    },
  },
  computed: {
    ...mapGetters('location', ['location', 'organization']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    setStatus() {
      this.testStore = this.location.testStore;
      this.reqUpdatedInfo = this.location.reqUpdatedInfo;
      this.hideCommercial = this.location.hideCommercial;
      this.installationDone = this.location.installationDone;
      this.twilioAlert = this.location.twilioAlert;
    },
    updateStore(data) {
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: 'success',
              title: 'Update Successfully',
            });
          this.setLocation(this.location.storeID);
        });
    },
    updateInstallation(val) {
      const data = { installationDone: this.installationDone };
      console.log('installation', data);
      this.updateStore(data);
    },
    updateTwilioAlert(val) {
      const data = { twilioAlert: this.twilioAlert };
      console.log('updateTwilioAlert', data);
      this.updateStore(data);
    },
    async updateTestStore(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          testStore: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.testStore = !this.testStore;
      }
    },
    async updateReqUpdatedInfo(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          reqUpdatedInfo: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.reqUpdatedInfo = !this.reqUpdatedInfo;
      }
    },
    async updateHideCommercial(val) {
      const { value: text } = await this.$swal.fire({
        title: 'Reason',
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        showCancelButton: true,
      });
      if (text) {
        const data = {
          lockReason: text,
          hideCommercial: val.value,
        };
        console.log('update locak', data);
        this.updateStore(data);
      } else {
        this.hideCommercial = !this.hideCommercial;
      }
    },
  },
};
</script>

<style scoped>
</style>
